import { useTranslation } from 'react-i18next';
import { isReviewerRole } from '@/utils/releaseRoles';

/**
 * Single source for displaying a team role (OWNER / ADMIN / MEMBER / REVIEWER).
 * Legacy 'CLIENT' is an alias of REVIEWER (see utils/releaseRoles.ts) and renders
 * with the Reviewer label. Unknown roles fall back to the raw value, humanised.
 */
export function useRoleLabel(): (role: string | null | undefined) => string {
  const { t } = useTranslation('common');
  return (role) => {
    if (!role) return t('role_member');
    if (isReviewerRole(role)) return t('role_reviewer');
    switch (role.trim().toUpperCase()) {
      case 'OWNER':
        return t('role_owner');
      case 'ADMIN':
        return t('role_admin');
      case 'MEMBER':
        return t('role_member');
      default:
        return role.replace(/_/g, ' ');
    }
  };
}
